import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm shadow-md'
    }`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer transform hover:scale-105 transition-transform duration-300">
            <img
              src="https://public.readdy.ai/ai/img_res/5fadbc43-5ecc-4654-9fa9-2d37db1411f5.png"
              alt="Proform Chimney Systems"
              className="h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link
              to="/services"
              className="text-gray-700 hover:text-orange-500 font-semibold transition-colors duration-300 cursor-pointer whitespace-nowrap relative group"
            >
              Services
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-500 group-hover:w-full transition-all duration-300"></span>
            </Link>
            
            <div className="relative group">
              <button className="text-gray-700 hover:text-orange-500 font-semibold transition-colors duration-300 flex items-center cursor-pointer whitespace-nowrap">
                About
                <i className="ri-arrow-down-s-line ml-1 group-hover:rotate-180 transition-transform duration-300"></i>
              </button>
              <div className="absolute top-full left-0 mt-2 w-56 bg-white rounded-xl shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 border border-gray-100">
                <Link
                  to="/about"
                  className="block px-6 py-3 text-gray-700 hover:bg-orange-50 hover:text-orange-500 transition-colors duration-300 rounded-t-xl cursor-pointer whitespace-nowrap font-medium"
                >
                  About Us
                </Link>
                <Link
                  to="/certificates"
                  className="block px-6 py-3 text-gray-700 hover:bg-orange-50 hover:text-orange-500 transition-colors duration-300 cursor-pointer whitespace-nowrap font-medium"
                >
                  Certificates
                </Link>
                <Link
                  to="/catalog"
                  className="block px-6 py-3 text-gray-700 hover:bg-orange-50 hover:text-orange-500 transition-colors duration-300 rounded-b-xl cursor-pointer whitespace-nowrap font-medium"
                >
                  Catalog
                </Link>
              </div>
            </div>

            <Link
              to="/contact"
              className="text-gray-700 hover:text-orange-500 font-semibold transition-colors duration-300 cursor-pointer whitespace-nowrap relative group"
            >
              Contact
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-500 group-hover:w-full transition-all duration-300"></span>
            </Link>

            <a
              href="https://wa.me/905434576196"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-5 py-2.5 rounded-xl font-semibold transition-all duration-300 flex items-center space-x-2 cursor-pointer whitespace-nowrap shadow-md hover:shadow-lg transform hover:scale-105"
            >
              <i className="ri-whatsapp-fill text-xl"></i>
              <span>WhatsApp</span>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-orange-500 cursor-pointer transition-colors duration-300"
          >
            <i className={`text-2xl transition-transform duration-300 ${isMenuOpen ? 'ri-close-line rotate-90' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        <div className={`md:hidden overflow-hidden transition-all duration-300 ${isMenuOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}>
          <nav className="py-4 border-t border-gray-200">
            <Link
              to="/services"
              className="block py-3 text-gray-700 hover:text-orange-500 hover:bg-orange-50 rounded-lg px-4 font-semibold transition-all duration-300 cursor-pointer"
              onClick={() => setIsMenuOpen(false)}
            >
              Services
            </Link>
            
            <div>
              <button
                onClick={() => setIsAboutOpen(!isAboutOpen)}
                className="w-full flex items-center justify-between py-3 px-4 text-gray-700 hover:text-orange-500 hover:bg-orange-50 rounded-lg font-semibold transition-all duration-300 cursor-pointer"
              >
                About
                <i className={`ri-arrow-${isAboutOpen ? 'up' : 'down'}-s-line transition-transform duration-300`}></i>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${isAboutOpen ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`}>
                <div className="pl-4 space-y-2 mt-2">
                  <Link
                    to="/about"
                    className="block py-2 px-4 text-gray-600 hover:text-orange-500 hover:bg-orange-50 rounded-lg transition-all duration-300 cursor-pointer font-medium"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    About Us
                  </Link>
                  <Link
                    to="/certificates"
                    className="block py-2 px-4 text-gray-600 hover:text-orange-500 hover:bg-orange-50 rounded-lg transition-all duration-300 cursor-pointer font-medium"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Certificates
                  </Link>
                  <Link
                    to="/catalog"
                    className="block py-2 px-4 text-gray-600 hover:text-orange-500 hover:bg-orange-50 rounded-lg transition-all duration-300 cursor-pointer font-medium"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Catalog
                  </Link>
                </div>
              </div>
            </div>

            <Link
              to="/contact"
              className="block py-3 text-gray-700 hover:text-orange-500 hover:bg-orange-50 rounded-lg px-4 font-semibold transition-all duration-300 cursor-pointer"
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </Link>

            <a
              href="https://wa.me/905434576196"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 py-3 px-4 mt-2 bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold rounded-lg cursor-pointer hover:from-green-600 hover:to-green-700 transition-all duration-300"
              onClick={() => setIsMenuOpen(false)}
            >
              <i className="ri-whatsapp-fill text-xl"></i>
              <span>WhatsApp</span>
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
}